/**
 * NotesSection — texto libre + firma del entrenador.
 */
import type { NotesData, PlanBrand } from "../../../types/plan";
import { InlineEditable } from "../InlineEditable";
import { PageHeader, SectionPage } from "./section-shared";

interface NotesSectionProps {
  data: NotesData;
  brand: PlanBrand | null;
  onChange: (next: NotesData) => void;
  readonly?: boolean;
}

export function NotesSection({ data, brand, onChange, readonly }: NotesSectionProps) {
  return (
    <SectionPage readonly={readonly}>
      <PageHeader eyebrow="Notas del entrenador" title="Notas del entrenador" />
      <div className="al-notes">
        <InlineEditable
          as="div"
          value={data.body || ""}
          onChange={(v) => onChange({ ...data, body: v })}
          multiline
          readonly={readonly}
          placeholder="Notas del entrenador…"
          fieldPath="body"
        />
      </div>
      <div className="al-signature">
        <div className="al-sign-line" />
        <div className="al-sign-name">
          <b>{brand?.name || "Tu entrenador"}</b>
        </div>
        <div className="al-sign-role">
          <InlineEditable
            value={data.signature || brand?.tagline || "ENTRENADOR PERSONAL"}
            onChange={(v) => onChange({ ...data, signature: v })}
            readonly={readonly}
            fieldPath="signature"
          />
        </div>
      </div>
    </SectionPage>
  );
}
